import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import Archive from '@material-ui/icons/Archive';
import ListAlt from '@material-ui/icons/ListAlt';
import { Theme } from '@orijinworks/frontend-commons';
import {
  CASE_PLAN_SECTION_STATUSES,
  CASE_PLAN_SECTION_TABS,
} from '../../../../constants/reentry-planning.constants';
import { SectionCountBadge, SectionToggleGroup } from './CasePlanSectionTabs.styles';

const SECTION_TABS_LABEL = 'Case plan sections';

const SECTION_TAB_ICONS = {
  [CASE_PLAN_SECTION_STATUSES.ACTIVE]: ListAlt,
  [CASE_PLAN_SECTION_STATUSES.ARCHIVED]: Archive,
};

const SECTION_TAB_EDGE_CLASSES = ['toggle-button-left', 'toggle-button-right'];

const buildSectionTabAriaLabel = (tab, activeSectionCount) => {
  if (tab.value === CASE_PLAN_SECTION_STATUSES.ACTIVE) {
    return `Active sections, ${activeSectionCount}`;
  }

  return `${tab.label} sections`;
};

/**
 * Exclusive ToggleButtonGroup emits `null` when the selected segment is clicked again.
 * Ignore that so the current view stays selected.
 */
const handleSectionTabChange = (onSectionTabChange) => (event, value) => {
  if (value === null) {
    return;
  }

  onSectionTabChange(event, value);
};

const renderActiveTabLabel = (label, activeSectionCount) => (
  <SectionCountBadge badgeContent={activeSectionCount} color="primary" showZero>
    {label}
  </SectionCountBadge>
);

const renderSectionTabContent = (tab, activeSectionCount) => {
  const Icon = SECTION_TAB_ICONS[tab.value];
  const label =
    tab.value === CASE_PLAN_SECTION_STATUSES.ACTIVE
      ? renderActiveTabLabel(tab.label, activeSectionCount)
      : tab.label;

  return (
    <>
      <Icon />
      {label}
    </>
  );
};

/**
 * Active/Archived switch above the section list. Only the Active segment carries a count, which
 * is the number of sections still active on the plan.
 */
export function CasePlanSectionTabs({ activeSectionTab, activeSectionCount, onSectionTabChange }) {
  return (
    <Theme>
      <SectionToggleGroup>
        <ToggleButtonGroup
          value={activeSectionTab}
          color="primary"
          exclusive
          aria-label={SECTION_TABS_LABEL}
          onChange={handleSectionTabChange(onSectionTabChange)}
          role="radiogroup"
        >
          {CASE_PLAN_SECTION_TABS.map((tab, index) => (
            <ToggleButton
              key={tab.value}
              id={tab.tabId}
              className={SECTION_TAB_EDGE_CLASSES[index]}
              value={tab.value}
              role="radio"
              aria-checked={activeSectionTab === tab.value}
              aria-controls={tab.panelId}
              aria-label={buildSectionTabAriaLabel(tab, activeSectionCount)}
            >
              {renderSectionTabContent(tab, activeSectionCount)}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </SectionToggleGroup>
    </Theme>
  );
}
